import { Environment } from './enviroment.model';

/**
 * The test build is served from more than one host (test.login.hippodata.de
 * and the Cloudflare deployment on test.hippodata.codext.de), so both the API
 * and the Cognito callbacks are resolved against whatever origin the app is
 * actually running on rather than pinned to one hostname.
 */
const appOrigin =
    typeof window === 'undefined'
        ? 'https://test.login.hippodata.de'
        : window.location.origin;

export const environment: Environment = {
    production: true,
    // Relative on purpose: same-origin either way — served directly by the PHP
    // host, or reverse-proxied to it by the Cloudflare Worker (see worker/).
    apiURL: '/api/',
    loginInitials: '',
    loginPassword: '',
    isTestSystem: true,
    cognito: {
        authority:
            'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_qArvNDcKj',
        clientId: '2jmj5n12uf5av6o4kbkelhmi1e',
        redirectUrl: appOrigin,
        postLogoutRedirectUri: appOrigin,
        scope: 'openid',
        responseType: 'code',
        hostedUiDomain: 'https://auth.longinesid.net',
    },
};
